import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppPageHeader } from "../../../../components";
import { Link, useLocation } from "react-router-dom";
// material ui
import { Stack, Box } from "@mui/material";
// icons
import CancelIcon from "@mui/icons-material/Cancel";
// components
import AddUserGroups from "./AddUserGroups";
import UpdateUserGroups from "./UpdateUserGroups";
import { MuiDataGrid, GridCellExpand, Notifier, ErrorNotifier } from "../../../../components";
import ConfirmDialog from "../../../../components/common/ConfirmDialog";
import Layout from "../../../../layout/Layout";
// redux
import {
  getUserGroups,
  deleteUserGroups,
  rowSelect,
  resetMessage,
  resetErrMessage,
} from "../../../../features/iam/role_management/userGroupsSlice";

// ----------------------------------------------------------------------------------

const UserGroups = () => {
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const location = useLocation()
  const dispatch = useDispatch();
  const { userGroupsData, selectedData, message, errMessage } =
    useSelector((state) => ({ ...state.userGroups }));

  function renderCellExpand(params) {
    return (
      <GridCellExpand
        value={params.value || ""}
        width={params.colDef.computedWidth}
      />
    );
  }

  const data = {
    rows: userGroupsData,
    columns: [
      { field: "groupName", headerName: "Group Name", width: 200 },
      {
        field: "groupDescription",
        headerName: "Group Description",
        width: 850,
        renderCell: renderCellExpand
      },
    ],
  };

  useEffect(() => {
    dispatch(getUserGroups());
  }, []);

  const handleSetConfirmDialog = (obj) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: obj.isOpen,
    });
  };

  const handleDelete = () => {
    let data = {
      id: selectedData?.id,
    };
    dispatch(deleteUserGroups(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          dispatch(getUserGroups());
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  return (
    <Layout>

      <>
        <AppPageHeader pathname="/exco/iam/roles" l3Menu={location?.state?.l3Menu} permissions={location?.state?.permissions} >
          User Groups
        </AppPageHeader>
        {/* <Stack flexDirection="row" justifyContent="space-between">
            <Box sx={{ width: "100%" }}>
              <PageHeader variant="pageHeader">User Groups</PageHeader>
            </Box>
            <Link to="/exco/iam/roles" state={{l3Menu: location?.state?.l3Menu}}>
              <CancelIcon color="red" />
            </Link>
          </Stack> */}
        <MuiDataGrid
          setShowAdd={location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "create") ? () => setShowAdd(true) : null}
          setShowEdit={location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "update") ? () => setShowEdit(true) : null}
          setShowDelete={location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "delete") ? () =>
            setConfirmDialog({
              isOpen: true,
              title: "Are you sure to delete this record?",
              subTitle: "You can't undo this operation",
              onConfirm: () => handleDelete(),
            }) : null
          }
          // setShowAdd={() => setShowAdd(true)}
          // setShowEdit={ () => setShowEdit(true)}
          // setShowDelete={() =>
          //   setConfirmDialog({
          //     isOpen: true,
          //     title: "Are you sure to delete this record?",
          //     subTitle: "You can't undo this operation",
          //     onConfirm: () => handleDelete(),
          //   })
          // }
          toolbarColumn={true}
          toolbarFilter={true}
          toolbarDensity={true}
          toolbarExport={true}
          data={data}
          select={(data) => dispatch(rowSelect(data))}
        />
      </>

      {showAdd && (
        <AddUserGroups showAdd={showAdd} close={() => setShowAdd(false)} />
      )}
      {showEdit && (
        <UpdateUserGroups
          showEdit={showEdit}
          close={() => setShowEdit(false)}
        />
      )}
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
      />
      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}
    </Layout>
  );
};

export default UserGroups;
